import React from 'react'
import "../Admin.css";
export default function BaseLayout(props) {
    return (
        <>
            { props.children }
        </>
    )
}
